$(document).ready(function(){

	if($("#new_contact").length == 1) display_action_of_requested_materials();
	$("#new_contact").on('click', "input[name='contact[requested_raw_materials_flag]']", function() {
		display_action_of_requested_materials();
	});

});

function display_action_of_requested_materials() {
	if($("input[name='contact[requested_raw_materials_flag]']:checked").val() === "bring_in"){
		$(".wrapper_requested_raw_materials").removeClass("requested_raw_materials--hidden");
	}else{
		$(".wrapper_requested_raw_materials").addClass("requested_raw_materials--hidden");
		$("textarea[name='contact[requested_raw_materials]']").val("");
	}
}